module.exports = __webpack_public_path__ + "img/not-visible-eye.3213d4e1.svg";